export default __webpack_public_path__ + "static/media/foot-insta.656a2107.png";